export default "__VITE_ASSET__B8Fj5hCz__"